export default __webpack_public_path__ + "static/media/img_declaration_slogan1.b26166fd.png";